import angular from 'angular';
import '../shared.module';
import { currencyBRL } from '../../core/helpers/string.helper';

angular.module('app.shared').filter('cpCurrencyBr', () => (value) => currencyBRL(value));
